import { Clickable, Col, Icon, Row, TabControl, Text } from 'components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { History, Settings, TeamSubscription } from './components';

const Billing = () => {
  const { isMobile } = useSelector((state) => state.appState),
    { t } = useTranslation(),
    location = useLocation(),
    navigate = useNavigate();

  // Get the query parameter from the URL
  const queryParams = new URLSearchParams(location.search);
  const initialTab = Number(queryParams.get('tab')) || 0;
  const [tab, setTab] = useState(initialTab);
  const athleteId = queryParams.get('athleteId'); // Extract athleteId from query params
  const athleteName = queryParams.get('athleteName');
  const cta = queryParams.get('cta');

  const handleBackButton = async () => {
    if (athleteId && (cta === 'requestShoutout' || cta === 'sendShoutout')) {
      navigate(`/profile/${athleteName}/${cta}`);
    } else if (athleteId) {
      navigate(`/subscribe/${athleteId}`);
    } else if (cta) {
      navigate(`/profile/${athleteName}`);
    } else {
      navigate('/settings');
    }
  };

  const tabOptions = [
    {
      title: t('billing.settings'),
      component: <Settings />
    },
    {
      title: t('billing.teamSubscription'),
      component: <TeamSubscription />
    },
    {
      title: t('billing.history'),
      component: <History />
    }
  ];

  return (
    <Col bg="#E5E5E5" pad="0 0 150px" minHt="100vh" start>
      <Col wid={isMobile ? '100%' : '936px'} ht="100%" noFlex={!isMobile} marg="0 auto" start>
        <Row noFlex start pad={isMobile && '0 16px'}>
          <Row centerAll noFlex marg={isMobile ? '16px 0 8px' : '38px 0 24px'}>
            <Clickable marg={isMobile ? '0 8px 0 0' : '0 16px 0 0'} onClick={handleBackButton}>
              <Row
                ht={isMobile ? '32px' : '40px'}
                wid={isMobile ? '32px' : '40px'}
                hasBorder="2px solid #000"
                hasRadius="32px"
                centerAll
              >
                <Icon type="arrowLeft" dimensions={16} col="#000" />
              </Row>
            </Clickable>

            <Text h1={!isMobile} h4={isMobile}>
              {t('billing.billing')}
            </Text>
          </Row>
        </Row>

        <TabControl
          marg={isMobile ? '8px 0 0' : '32px 0 0'}
          options={tabOptions}
          selectedIdx={tab}
          handleSelect={setTab}
        />

        <Col marg="32px 0 0" noFlex wid={'100%'}>
          {tabOptions[tab].component}
        </Col>
      </Col>
    </Col>
  );
};

export default Billing;
